import { Box, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import {
  OverviewCard,
  PageTitleAndSubTitle,
  Breadcrumbs,
  CardComponent,
  BasicTable,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  CostValues,
  MemberValues,
  PEPM,
  PMPM,
  TotalCost,
} from '../../core-utils/helper-utils/summaryReportHelper';
import { COMMON_TEXTS } from '../../core-utils/messages/CommonConstants';
import { DEEP_DIVE, RX_UTILIZATION } from '../../core-utils/routes';
import { useStores } from '../../stores';
import Loader from '../../_components/molecules/Loader';
import TabSelection from '../../_components/molecules/TabSelection';
import ReportsModal from '../../_components/organisms/ReportsModal';
import { pageScrollDown } from '../SummaryPage';
import OverviewCardTooltipContent from '../../_components/atoms/OverviewCardTooltipContent';
import { getCohortValue } from '../../core-utils/helper-utils/overviewCardHelper';
// import DrugSurgeChart from '@HomaHealth/ui-component-library/lib/_AIQ-components/molecules/DrugSurgeChart';
// import DrugCategoriesChart from '@HomaHealth/ui-component-library/lib/_AIQ-components/molecules/DrugCategoriesChart';
// import TopUtilizationChart from '@HomaHealth/ui-component-library/lib/_AIQ-components/molecules/TopUtilizationChart';
import MED_PHARMA_MESSAGES from './textConstants';
import utilizationRx from '../../core-utils/messages/utilizationRx';
import properties from '../../core-utils/properties';
import axios from 'axios';
// import { roundNumber } from '../../core-utils/helper-utils/helper';
// import {
//   // IDrugCategories,
//   ILabel,
//   IValue,
//   // formatDrugCategoriesResponse,
//   // formatMedicalDrugSurgeResponse,
// } from '../../core-utils/helper-utils/pharmacySpendHelper';
import { commasForNumbers } from '../../core-utils/helper-utils/helper';
import { numFormatterWithSuffix } from '../../core-utils/helper-utils/helper';
import componentConstants from '../../core-utils/messages/componentConstants';
import RecommendationsTab from '../../_components/organisms/RecommendationsTab';
import { getRecommendationsData } from '../../core-utils/helper-utils/recommendationsTabHelper';
import Snackbar from '../../_components/atoms/Snackbar';
import { Pagination } from '@mui/material';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import { downloadPdf } from '../../core-utils/helper-utils/downloadPdfHelper';
import DateFilter from '../../_components/molecules/DateFilter';
import usePlanDates from '../../core-utils/custom-hooks/PlanDates';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import useTotalEligible from '../../core-utils/custom-hooks/TotalEligible';
import {
  formatTopDrugsData,
  topDrugsTableColumnsForMedPharma,
} from '../UtilizationRx/utilizationRxConstants';
import { CircularLoader } from '@HomaHealth/ui-component-library';
import {
  handleHeaderMouseEnter,
  handleHeaderMouseLeave,
} from '../../core-utils/helper-utils/tableSortHelper';
import { observer } from 'mobx-react';
import AiSummaryCard from '../../_components/molecules/AiSummaryCard';
import allScreenLabel from '../../core-utils/messages/screenNamesForPrompts';
import {
  checkUserAccess,
  UserAccessConstants,
} from '../../core-utils/helper-utils/userAccess';
import CohortDetailsModal from '../../_components/organisms/CohortDetailsModalNew';
import CohortFilterBar from '../../_components/molecules/CohortFilterBar';
import { useCohortModal } from '../../core-utils/custom-hooks/useCohortModal';
import { useCohortOnPageLoad } from '../../core-utils/custom-hooks/useCohortPageOnLoad';
import { getCohortMemberCountForMedpharma } from '../../core-utils/axios/Cohort/MedPharma';

// interface IDrugSurgeChartData {
//   labels: ILabel[];
//   currentYearValues: IValue[];
//   previousYearValues: IValue[];
// }

const MedPharmaPage = observer(() => {
  const useStyles = makeStyles()({
    root: {
      display: 'flex',
      flexDirection: 'column',
      padding: '40px 0px 66px 63px',
      width: '1182px',
    },
  });

  const { classes } = useStyles();

  const {
    employerGroupStore,
    quaterlyReportStore,
    loginPageStore,
    cohortDetailsStore,
    recommendedTabStore,
  } = useStores();

  const {
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    isIncurredDate,
    isPaidDate,
    isPlanDatesFetched,
    aggregationParameter,
  } = quaterlyReportStore;

  const { getPlanDates, loading: isPlanDatesLoading } = usePlanDates();
  const payload = useAPIPayload();
  const { open, openModal, closeModal, isEditMode } = useCohortModal();

  const { totalResults, memberIds, isInitializing } = useCohortOnPageLoad({
    fetchTotalResults: () =>
      getCohortMemberCountForMedpharma(
        employerGroupStore.employerGroupResponseData.eg_nid,
        incurredStartDate,
        incurredEndDate,
        paidStartDate,
        paidEndDate,
        aggregationParameter,
      ),
    enabled:
      isPlanDatesFetched &&
      !!employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
    isInternal: true,
  });
  const abortController = new AbortController();

  const [openReportsModal, setOpenReportsModal] = useState(false);
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  // const [top10UtilisationsPlans, setTop10UtilisationsPlans] = useState<any[]>(
  //   [],
  // );
  // const [
  //   top10UtilisationsInHospitalData,
  //   setTop10UtilisationsInHospitalData,
  // ] = useState<any[]>([]);
  // const [
  //   top10UtilisationsOutHospitalData,
  //   setTop10UtilisationsOutHospitalData,
  // ] = useState<any[]>([]);
  // const [
  //   top10UtilisationsPhysiciansData,
  //   setTop10UtilisationsPhysiciansData,
  // ] = useState<any[]>([]);
  // const [
  //   top10UtilisationsPatientsData,
  //   setTop10UtilisationsPatientsData,
  // ] = useState<any[]>([]);
  // const [
  //   top10UtilisationsOthersData,
  //   setTop10UtilisationsOthersData,
  // ] = useState<any[]>([]);
  // //Text Constants :
  const messages = MED_PHARMA_MESSAGES;

  const pageConstants = componentConstants.PAGES.PHARMACY_SPEND_PAGES;
  const snackBarMessages = componentConstants.ORGANISMS.REPORTS_MODAL;
  //OverView Cards Use States:

  const [memberValues, setMemberValues] = useState<MemberValues>({
    members: '0',
    employees: '0',
    dependents: '0',
  });

  const [costValues, setCostValues] = useState<CostValues>({
    rx: '$0.00',
    medical: '$0.00',
    total: '$0.00',
  });

  const [totalCost, setTotalCost] = useState<TotalCost>({
    totalCost: '',
    totalMedical: '',
    totalRx: '',
  });

  const [pmpm] = useState<PMPM>({
    pmpm: '',
    pmpmPercentage: '',
    increment: true,
  });

  const [pepm] = useState<PEPM>({
    pepm: '',
    pepmPercentage: '',
    increment: true,
  });
  const [isTopDrugsTableLoading, setIsTopDrugsTableLoading] = useState<boolean>(
    false,
  );
  const [
    topDrugsTableCurrentPage,
    setTopDrugsTableCurrentPage,
  ] = useState<number>(1);
  const [sortField, setSortField] = useState(pageConstants.MAIN_SORT_COLUMN);
  const [sortOrder, setSortOrder] = useState(pageConstants.MAIN_SORT_ORDER);
  const [
    isPreviousYearAvailable,
    setIsPreviousYearAvailable,
  ] = useState<boolean>(true);
  const [topDrugsTableData, setTopDrugsTableData] = useState<any>([]);
  const [
    topDrugsTableTotalPages,
    setTopDrugsTableTotalPages,
  ] = useState<number>(20);
  const [columnId, setColumnId] = useState<string>();

  //charts data
  // const [
  //   drugSurgeChartData,
  //   setDrugSurgeChartData,
  // ] = useState<IDrugSurgeChartData>({
  //   currentYearValues: [],
  //   labels: [],
  //   previousYearValues: [],
  // });

  // const [
  //   drugCategoriesOfCancerChartData,
  //   setDrugCategoriesOfCancerChartData,
  // ] = useState<IDrugCategories[]>([]);

  // const [
  //   drugCategoriesOfNonCancerChartData,
  //   setDrugCategoriesOfNonCancerChartData,
  // ] = useState<IDrugCategories[]>([]);

  //snacker bar variables and functions
  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });
  const [aiLoading, setAiLoading] = useState<boolean>(false);
  const screenName = allScreenLabel;
  const [activeAskAi, setActiveAskAi] = useState<boolean>(false);
  const [aiSummaryData, setAiSummaryData] = useState<
    { title: string; description: string }[]
  >([]);
  const handleCloseSnackBar = () => {
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };
  const [recommendationLoading, setRecommendationLoading] = useState<boolean>(
    false,
  );
  const [recommendationFetched, setRecommendationFetched] = useState<boolean>(
    false,
  );
  const handleSelectedIndex = (index: number) => {
    setSelectedTabIndex(index);
    if (!recommendationFetched) {
      getRecommendationsData(
        employerGroupStore?.employerGroupResponseData?.eg_nid,
        messages.PAGE_HEADINGS.TITLE,
        recommendedTabStore,
        setRecommendationLoading,
      );
      setRecommendationFetched(true);
    }
  };

  const handleTopDrugsTablePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    setTopDrugsTableCurrentPage(value);
  };

  const handleSort = (event: any, column: any, item: any) => {
    const sortOrder = item.actionType === 'ascendingSorting' ? 1 : -1;
    const { sortColumnName } = column;
    if (!sortColumnName) {
      return;
    }

    setSortField(sortColumnName);
    setSortOrder(sortOrder);
  };

  const handleOnClick = (value: string, key: string) => {
    navigate(DEEP_DIVE, {
      state: {
        key: key,
        value: value,
      },
    });
  };
  const handleAskAi = () => {
    setActiveAskAi(true);
    getAiSummarizedData();
  };

  const getTopDrugsTableColumns = () => {
    return topDrugsTableColumnsForMedPharma;
  };

  //Use History:
  const navigate = useNavigate();

  const {
    overAllEnrolled,
    overallTotalCost,
    getTotalEligible,
  } = useTotalEligible(
    aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
    aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
    employerGroupStore,
    abortController.signal,
  );

  //API CALLS AND DATA FORMATTING:

  const getSummary = async () => {
    const url =
      properties.aiqBaseUrl +
      properties.pharmacySpend +
      properties.pharmacySummary;

    const requestBody = {
      ...payload,
      claim_type: '',
      speciality_drug_type: 'Medpharma',
      member_id_list: cohortDetailsStore.memberUniqueIdList,
    };

    const defaultResponse = {
      memberIdList: [],
      numberOfEmployees: 0,
      numberOfDependents: 0,
      totalCost: 0,
    };

    return await axios
      .post(url, requestBody, { signal: abortController.signal })
      .then((res: any) => {
        if (res?.status === 200) {
          return res?.data?.data;
        }
        return defaultResponse;
      })
      .catch(() => {
        return defaultResponse;
      });
  };

  const getTopDrugsTableData = async () => {
    const baseUrl =
      properties.aiqBaseUrl +
      properties.utilizationRxBaseUrl +
      properties.topDrugs;
    const body = {
      ...payload,
      claim_id_list: cohortDetailsStore.claimIdList,
      member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
      medicationTypeList: ['Medpharma'],
      pageNumber: topDrugsTableCurrentPage - 1,
      sortField: sortField,
      sortOrder: sortOrder,
    };
    setIsTopDrugsTableLoading(true);
    await axios
      .post(baseUrl, body, { signal: abortController.signal })
      .then((res: any) => {
        if (res?.status === 200) {
          setIsPreviousYearAvailable(res?.data?.data?.isPreviousYearAvailable);
          setTopDrugsTableData(
            formatTopDrugsData(
              res?.data?.data?.topDrugs,
              true,
              false,
              handleOnClick,
            ),
          );
          setTopDrugsTableTotalPages(
            Math.ceil(res?.data?.data?.totalCount / 10),
          );
          setIsTopDrugsTableLoading(false);
        }
      })
      .catch((error) => {
        setIsTopDrugsTableLoading(false);
        handleOpenSnackBar(
          error.response?.data?.error ?? 'Something went wrong',
          'error',
          8000,
        );
      });
  };

  const getAiSummarizedData = async () => {
    try {
      setAiLoading(true);

      const topDrugsUrl =
        properties.aiqBaseUrl +
        properties.utilizationRxBaseUrl +
        properties.topDrugs;

      const reqBody = {
        ...payload,
        claim_id_list: cohortDetailsStore.claimIdList,
        member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
        medicationTypeList: ['Medpharma'],
        sortField: 'totalCost',
        sortOrder: -1,
        showAll: true,
      };

      const [topDrugsRes, summaryRes] = await Promise.all([
        axios.post(topDrugsUrl, reqBody),
        getSummary(),
      ]);

      const topDrugsData = topDrugsRes?.data?.data?.topDrugs || [];
      const summaryData = summaryRes || {};

      const apiResponses = {
        title_1: summaryData,
        title_2: topDrugsData,
      };

      let resultArray = []; // ✅ default fallback

      try {
        const response = await axios.post(
          properties.aiqBaseUrl +
            properties.contractBaseUrl +
            properties.getAiSummary,
          {
            screenName: screenName.PHARMACY_UTILIZATION,
            eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
            incurredStartDate,
            incurredEndDate,
            paidStartDate,
            paidEndDate,
            apiData: apiResponses,
          },
        );

        // ✅ Safe extraction
        resultArray = response?.data?.data?.data?.result || [];
        setAiSummaryData(Array.isArray(resultArray) ? resultArray : []);
      } catch (apiError) {
         
        console.error('AI Summary API failed:', apiError);
        // ✅ Optional: show user-friendly message
        handleOpenSnackBar('Failed to load summary', 'warning', 4000);
        setAiSummaryData([]);
      }
    } catch (error: any) {
      handleOpenSnackBar(
        error?.message ?? 'AI summarization failed',
        'error',
        6000,
      );
    } finally {
      setAiLoading(false);
    }
  };

  // const getDrugSurgeChartData = async () => {
  //   const url =
  //     properties.aiqBaseUrl +
  //     properties.pharmacySpend +
  //     properties.pharmacySpendMedical +
  //     properties.drugSurge;

  //   const requestBody = {
  //     ...payload,
  //     member_id_list: [],
  //   };

  //   const defaultResponse = {
  //     labels: [],
  //     currentYearValues: [],
  //     previousYearValues: [],
  //   };

  //   return await axios
  //     .post(url, requestBody, { signal: abortController.signal })
  //     .then((res: any) => {
  //       if (res?.status === 200) {
  //         return formatMedicalDrugSurgeResponse(res?.data?.data);
  //       }
  //       return defaultResponse;
  //     })
  //     .catch(() => {
  //       return defaultResponse;
  //     });
  // };

  // const getTop10UtilisationsData = async () => {
  //   const baseUrl =
  //     properties.aiqBaseUrl +
  //     properties.pharmacySpend +
  //     properties.top10Utilisations;
  //   const body = {
  //     ...payload,
  //     member_unique_id_list: [],
  //   };
  //   await axios
  //     .post(baseUrl, body, { signal: abortController.signal })
  //     .then((res: any) => {
  //       const plans: any[] = [];
  //       const inHospitalData: any[] = [];
  //       const outHospitalData: any[] = [];
  //       const physiciansData: any[] = [];
  //       const patientHomeData: any[] = [];
  //       const othersData: any[] = [];
  //       let othersSum = 0;
  //       res?.data?.data?.map((chronicGroupData: any) => {
  //         plans?.push(chronicGroupData?.chronicDiseaseGroupName);
  //         // eslint-disable-next-line max-nested-callbacks
  //         chronicGroupData?.groupDetails?.map((chronicGroupDetails: any) => {
  //           const placeOfServiceDesc = chronicGroupDetails?.placeOfServiceDesc;
  //           const value = roundNumber(chronicGroupDetails?.medicalTotalPaid, 2);
  //           switch (placeOfServiceDesc) {
  //             case 'Inpatient Hospital':
  //               inHospitalData?.push({
  //                 value: value.toFixed(2),
  //               });
  //               break;
  //             case 'On Campus-Outpatient Hospital':
  //               outHospitalData?.push({
  //                 value: value.toFixed(2),
  //               });
  //               break;
  //             case 'Off Campus-Outpatient Hospital':
  //               outHospitalData?.push({
  //                 value: value.toFixed(2),
  //               });
  //               break;
  //             case 'Office':
  //               physiciansData?.push({
  //                 value: value.toFixed(2),
  //               });
  //               break;
  //             case 'Home':
  //               patientHomeData?.push({
  //                 value: value.toFixed(2),
  //               });
  //               break;
  //             default:
  //               othersSum += value;
  //           }
  //         });
  //         othersData?.push({ value: othersSum.toFixed(2) });
  //       });
  //       setTop10UtilisationsPlans(plans);
  //       setTop10UtilisationsInHospitalData(inHospitalData);
  //       setTop10UtilisationsOutHospitalData(outHospitalData);
  //       setTop10UtilisationsPhysiciansData(physiciansData);
  //       setTop10UtilisationsPatientsData(patientHomeData);
  //       setTop10UtilisationsOthersData(othersData);
  //     })
  //     .catch(() => {});
  // };

  // const getDrugCategoriesChartData = async (
  //   categoryType: 'Cancer' | 'Non-cancer',
  // ) => {
  //   const url =
  //     properties.aiqBaseUrl +
  //     properties.pharmacySpend +
  //     properties.pharmacySpendMedical +
  //     properties.drugCategories;

  //   const requestBody = {
  //     ...payload,
  //     member_id_list: [],
  //     drug_category_type: categoryType,
  //   };

  //   return await axios
  //     .post(url, requestBody, { signal: abortController.signal })
  //     .then((res: any) => {
  //       if (res?.status === 200) {
  //         return formatDrugCategoriesResponse(res?.data?.data);
  //       }
  //       return [];
  //     })
  //     .catch(() => {
  //       return [];
  //     });
  // };

  const apiCalls = async () => {
    setLoading(true);
    isPlanDatesFetched &&
      (await Promise.all([
        // getDrugSurgeChartData(),
        // getDrugCategoriesChartData('Cancer'),
        // getDrugCategoriesChartData('Non-cancer'),
        // getTop10UtilisationsData(),
        getSummary(),
        getTotalEligible(),
      ]).then((responses) => {
        // const { labels, currentYearValues, previousYearValues } = responses[0];
        // setDrugSurgeChartData({
        //   labels,
        //   currentYearValues,
        //   previousYearValues,
        // });
        // setDrugCategoriesOfCancerChartData(responses[1]);
        // setDrugCategoriesOfNonCancerChartData(responses[2]);
        setCostValues({
          total: '$' + commasForNumbers(responses[0].totalCost, 2),
          medical: '',
          rx: '',
        });
        setTotalCost({
          totalCost: '$' + numFormatterWithSuffix(responses[0].totalCost, 2),
          totalMedical: '',
          totalRx: '',
        });
        setMemberValues({
          members: commasForNumbers(
            String(
              responses[0].numberOfEmployees + responses[0].numberOfDependents,
            ),
          ),
          dependents: commasForNumbers(String(responses[0].numberOfDependents)),
          employees: commasForNumbers(String(responses[0].numberOfEmployees)),
        });
        setLoading(false);
      }));
  };

  //useEffects:

  useEffect(() => {
    if (isInitializing) {
      return;
    }
    apiCalls();

    return () => {
      abortController.abort();
    };
  }, [
    isInitializing,
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    cohortDetailsStore.conditionsDetails,
  ]);

  useEffect(() => {
    if (isInitializing) {
      return;
    }
    isPlanDatesFetched && getTopDrugsTableData();
  }, [
    isInitializing,
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    topDrugsTableCurrentPage,
    sortField,
    sortOrder,
    cohortDetailsStore.conditionsDetails,
  ]);

  useEffect(() => {
    if (!employerGroupStore?.employerGroupResponseData?.eg_nid[0]) {
      return;
    }
    const fetchPlanDates = async () => {
      if (!isPlanDatesFetched) {
        await getPlanDates();
      }
    };

    fetchPlanDates();
  }, [employerGroupStore?.employerGroupResponseData?.eg_nid]);

  // Page Components:
  const MedPharmaComponents = () => {
    const useStyles = makeStyles()({
      root: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        marginBottom: '1rem',
      },
    });

    const { classes } = useStyles();
    return (
      <>
        <Grid container className={classes.root}>
          <CohortFilterBar />
          <Grid style={{ display: 'flex' }}>
            <Grid style={{ marginRight: '24px' }}>
              <OverviewCardTooltipContent
                type="member"
                cohortMemberValues={memberValues}
                totalMemberValues={{
                  dependents: overAllEnrolled.dependents,
                  employees: overAllEnrolled.employees,
                  members: overAllEnrolled.totalCount,
                }}
                overviewCard={
                  <OverviewCard
                    title={messages.OVERVIEW_CARDS.MEMBERS}
                    value={getCohortValue(
                      memberValues.members,
                      overAllEnrolled.totalCount,
                    )}
                    rootStyles={{
                      width: '176px',
                      height: '100px',
                    }}
                  />
                }
              />
            </Grid>

            <Grid style={{ marginRight: '24px' }}>
              <OverviewCardTooltipContent
                type="cost"
                hideDetailedInfo={true}
                cohortCostValues={costValues}
                totalCostValues={{
                  medical: overallTotalCost.totalMedical,
                  rx: overallTotalCost.totalRx,
                  total: overallTotalCost.totalCost,
                }}
                overviewCard={
                  <OverviewCard
                    title={messages.OVERVIEW_CARDS.COST}
                    value={getCohortValue(
                      (totalCost?.totalCost).toString(),
                      overallTotalCost.totalCost,
                    )}
                    rootStyles={{
                      width: '216px',
                    }}
                  />
                }
              />
            </Grid>

            {/* temporary disabling pmpm and pepm cards */}
            <Grid style={{ marginRight: '24px', display: 'none' }}>
              <OverviewCard
                title={messages.OVERVIEW_CARDS.PMPM}
                value={pmpm?.pmpm}
                rootStyles={{
                  width: '176px',
                  height: '100px',
                }}
              />
            </Grid>

            <Grid style={{ marginRight: '24px', display: 'none' }}>
              <OverviewCard
                title={messages.OVERVIEW_CARDS.PEPM}
                value={pepm?.pepm}
                rootStyles={{
                  width: '176px',
                  height: '100px',
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid>
          <CardComponent
            title={pageConstants.TOP_DRUGS}
            subTitle={pageConstants.TOP_DRUGS_SUBTITLE}
            height="auto"
            width="1177px"
            body={
              isTopDrugsTableLoading ? (
                <Box
                  style={{
                    display: 'flex',
                    height: '450px',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <CircularLoader />
                </Box>
              ) : (
                <>
                  <Grid style={{ margin: '7px 0px 0px 6px' }}>
                    <BasicTable
                      columns={getTopDrugsTableColumns()}
                      cellHeight="56px"
                      cellPadding="12px 9px 12px 14px"
                      rowsData={topDrugsTableData}
                      displayType="row"
                      tableHeight="auto"
                      columnId={columnId}
                      handleHeaderMouseEnter={(column: any) =>
                        handleHeaderMouseEnter(column, setColumnId)
                      }
                      handleHeaderMouseLeave={() =>
                        handleHeaderMouseLeave(setColumnId)
                      }
                      showOnHoverHeader={true}
                      handleMenuItem={handleSort}
                      width="1100px"
                      hideColumnIndex={!isPreviousYearAvailable ? 2 : -1}
                      noDataText={messages.NO_DATA}
                    />
                  </Grid>
                  <Grid
                    container
                    style={{
                      marginTop: '16px',
                    }}
                    sx={{
                      justifyContent: 'flex-end',
                    }}
                  >
                    <Pagination
                      page={topDrugsTableCurrentPage}
                      count={topDrugsTableTotalPages}
                      onChange={handleTopDrugsTablePageChange}
                      size="small"
                      color="primary"
                    />
                  </Grid>
                </>
              )
            }
          />
        </Grid>
        {/* <Box style={{ marginBottom: '28px' }}>
          <DrugSurgeChart
            isMedPharma={true}
            xAxisLabel={drugSurgeChartData.labels}
            currentYearData={drugSurgeChartData.currentYearValues}
            previousYearData={drugSurgeChartData.previousYearValues}
            legendsData={messages.DRUG_SURGE_CHART.LEGENDS_DATA}
            cardHeight={'443px'}
          />
        </Box>
        <Box style={{ display: 'flex', marginBottom: '28px' }}>
          <Box style={{ marginRight: '24px' }}>
            <DrugCategoriesChart
              title={pageConstants.DRUG_CATEGORIES_CANCER_TITLE}
              subTitle={pageConstants.DRUG_CATEGORIES_CANCER_SUBTITLE}
              cardHeight={'341px'}
              data={drugCategoriesOfCancerChartData}
            />
          </Box>
          <Box>
            <DrugCategoriesChart
              title={pageConstants.DRUG_CATEGORIES_NON_CANCER_TITLE}
              subTitle={pageConstants.DRUG_CATEGORIES_NON_CANCER_SUBTITLE}
              cardHeight={'341px'}
              data={drugCategoriesOfNonCancerChartData}
            />
          </Box>
        </Box>
        <Box>
          <TopUtilizationChart
            inPatientHospitalsData={top10UtilisationsInHospitalData}
            outPatientHospitalsData={top10UtilisationsOutHospitalData}
            physiciansData={top10UtilisationsPhysiciansData}
            patientHomeData={top10UtilisationsPatientsData}
            othersData={top10UtilisationsOthersData}
            plans={top10UtilisationsPlans}
            width={'1176px'}
            height={'650px'}
            widthChart={'1070'}
            heightChart={'500'}
          />
        </Box> */}
      </>
    );
  };

  const isPageLoading = isPlanDatesLoading || loading || isInitializing;

  return (
    <>
      {isPageLoading ? (
        <Loader />
      ) : (
        <div>
          <Grid container className={classes.root}>
            <Grid style={{ marginBottom: '20px' }}>
              <Breadcrumbs
                itemList={[
                  [
                    'text',
                    utilizationRx.titleAndSubtitle.title,
                    {
                      color: patientAccessTheme.palette.primary[500],
                      fontWeight: 500,
                    },
                    () => {
                      navigate(RX_UTILIZATION);
                    },
                  ],
                  [
                    'text',
                    messages.PAGE_HEADINGS.TITLE,
                    {
                      color: patientAccessTheme.palette.text.highemphasis,
                      fontWeight: 600,
                    },
                  ],
                ]}
              />
            </Grid>

            <Grid
              style={{
                marginBottom: '1rem',
                position: 'relative',
              }}
            >
              <PageTitleAndSubTitle
                title={messages.PAGE_HEADINGS.TITLE}
                subTitle={messages.PAGE_HEADINGS.SUB_TITLE}
                showDownloadButton={true}
                downloadButtonAction={() => {
                  downloadPdf(
                    'individualPharmacyUtilizationReport',
                    {
                      startDate:
                        aggregationParameter === 'paid'
                          ? paidStartDate
                          : incurredEndDate,
                      endDate:
                        aggregationParameter === 'paid'
                          ? paidEndDate
                          : incurredEndDate,
                      employer:
                        employerGroupStore?.employerGroupResponseData
                          ?.employer_group_name,
                      member_unique_id_list: [],
                      claim_id_list: [],
                      category: 'medPharma',
                      maxClaimDate:
                        employerGroupStore?.employerGroupResponseData
                          ?.max_claim_date,
                      ...payload,
                    },
                    handleOpenSnackBar,
                    'open',
                  );
                  handleOpenSnackBar(
                    snackBarMessages.SNACKBAR_MESSAGES.OPEN_REPORT,
                    'info',
                    6000,
                  );
                }}
                showAskAi={true}
                askAiAction={handleAskAi}
                showQueryDataButton={checkUserAccess(
                  UserAccessConstants.COHORT_DETAILS,
                  loginPageStore.userResponse.role.name,
                  loginPageStore.userFeatures,
                )}
                queryButtonText={
                  cohortDetailsStore.cohortDetailsList?.length > 0 &&
                  cohortDetailsStore.cohortDetailsList[0].category !== ''
                    ? 'Edit Cohort'
                    : 'Add Cohort'
                }
                queryDataAction={() => {
                  if (
                    checkUserAccess(
                      UserAccessConstants.COHORT_DETAILS,
                      loginPageStore.userResponse.role.name,
                      loginPageStore.userFeatures,
                    )
                  ) {
                    openModal();
                  }
                }}
              />
              <div
                style={{
                  position: 'absolute',
                  top: '-1px',
                  left: '107px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Typography
                  fontSize="17px"
                  lineHeight="21px"
                  textColor={patientAccessTheme.palette.text.mediumemphasis}
                  fontType="semiBold"
                  margin="0px 8px"
                >
                  {COMMON_TEXTS.FOR}
                </Typography>
                <DateFilter />
              </div>
              <TabSelection
                selectedTabIndex={selectedTabIndex}
                setSelectedTabIndex={handleSelectedIndex}
                recommendationFetched={recommendationFetched}
              />
            </Grid>
            <Grid>
              {selectedTabIndex === 0 && (
                <>
                  <MedPharmaComponents />
                </>
              )}
              {selectedTabIndex === 1 && (
                <RecommendationsTab
                  recommendationLoading={recommendationLoading}
                  isInternalPage={false}
                />
              )}
            </Grid>
            <div id="scroll-top-element" />
          </Grid>
          {pageScrollDown('scroll-top-element')}
        </div>
      )}
      <ReportsModal
        open={openReportsModal}
        setOpen={setOpenReportsModal}
        startDate={
          aggregationParameter === 'paid' ? paidStartDate : incurredStartDate
        }
        endDate={
          aggregationParameter === 'paid' ? paidEndDate : incurredEndDate
        }
      />
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
      <AiSummaryCard
        open={activeAskAi}
        onClose={() => {
          setActiveAskAi(false);
          setAiSummaryData([]);
        }}
        aiSummaryData={aiSummaryData}
        loading={aiLoading}
      />
      <CohortDetailsModal
        open={open}
        handleClose={closeModal}
        totalResults={totalResults}
        isEditMode={isEditMode}
        existingMemberUniqueIds={memberIds}
      />
    </>
  );
});

export default MedPharmaPage;
